import React, { useState, useEffect } from 'react';
import logo from './g6sample.png';
import lpanel from './lpanelram.PNG';
import bsamp from './BeardBoardSamp.PNG';
import fpanel from './flush.png';
import bg8 from './bg_8ft.png';
import bg14 from './bg_14ft.png';
import bg16 from './bg_16ft.png';

// 3D Perspective Configuration
export const config3D = {
  8: {
    bg: bg8,
    w: 1019,
    h: 901,
    bgScale: 1.00,
    top: 421,
    left: 136,
    scale: 0.51,
    stretchX: 0.97,
    stretchY: 1.03,
    rotateY: '31deg',
    rotateZ: '0deg',
    skewY: '-0.5deg'
  },
  14: {
    bg: bg14,
    w: 1021,
    h: 854,
    bgScale: 1.09,
    top: 340,
    left: 464,
    scale: 0.29,
    stretchX: 1.05,
    stretchY: 1.37,
    rotateY: '-41deg',
    rotateZ: '-0.3deg',
    skewY: '0.5deg'
  },
  16: {
    bg: bg16,
    w: 1362,
    h: 735,
    bgScale: 1.00,
    top: 230,
    left: 99,
    scale: 0.50,
    stretchX: 0.65,
    stretchY: 0.96,
    rotateY: '2deg',
    rotateZ: '0deg',
    skewY: '0.5deg'
  }
};

const getWindowImage = (shape, color, index) => {
  let finalShape = shape;
  if (shape === 'sunrise') {
    finalShape = `sunrise${(index % 2) + 1}`;
  } else if (shape === 'flushLeft' || shape === 'flushRight') {
    finalShape = 'flushwindow';
  }
  try {
    return require(`./windows/${finalShape}_${color}.png`);
  } catch (e) {
    return null;
  }
};

const WindowOverlay = ({ shape, color, index }) => {
  const imgSrc = getWindowImage(shape, color, index);
  if (!imgSrc) return null;

  let style = {
    position: 'absolute',
    top: '18%',
    left: '10%',
    width: '80%',
    height: '64%',
    zIndex: 10
  };

  if (shape === 'flushLeft') {
    style = { position: 'absolute', top: '15%', left: '5%', width: '30%', height: '70%', zIndex: 10 };
  } else if (shape === 'flushRight') {
    style = { position: 'absolute', top: '15%', right: '5%', width: '30%', height: '70%', zIndex: 10 };
  }

  return (
    <img
      src={imgSrc}
      alt={`${shape} window`}
      style={style}
    />
  );
};

function Function1(setss, colorSelects, hasWindows, colors) {
  const containerStyle = {
    width: '120px',
    height: '80px',
    margin: '0',
    padding: '0',
    position: 'relative',
    overflow: 'hidden'
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'fill',
    margin: '0',
    padding: '0',
    position: 'relative',
    display: 'block',
    transform: 'scale(1.05)'
  };

  const overlayStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '120px',
    height: '80px',
    backgroundColor: colorSelects
  };

  const images = Array.from({ length: setss * 4 }).map((_, index) => (
    <div key={`img-container-${index}`} style={containerStyle}>
      <img
        key={`img-${index}`}
        src={logo}
        alt="panel background"
        style={imageStyle}
      />
      <div style={overlayStyle} />
      {hasWindows !== 'none' && index < setss && <WindowOverlay shape={hasWindows} color={colors} index={index} />}
    </div>
  ));

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${setss}, 120px)`,
        gridTemplateRows: `repeat(4, 80px)`,
        gap: '0',
        padding: "0px",
        border: "none",
        backgroundColor: '#111'
      }}
    >
      {images}
    </div>
  );
}

function Function2(setss, colorSelects, hasWindows, colors) {
  setss = setss / 2;
  const containerStyle = {
    width: '240px',
    height: '80px',
    margin: '0',
    padding: '0',
    position: 'relative',
    overflow: 'hidden'
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'fill',
    margin: '0',
    padding: '0',
    position: 'relative',
    display: 'block',
    transform: 'scale(1.05)'
  };

  const overlayStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '240px',
    height: '80px',
    backgroundColor: colorSelects
  };

  const images = Array.from({ length: setss * 4 }).map((_, index) => (
    <div key={`img-container-${index}`} style={containerStyle}>
      <img
        key={`img-${index}`}
        src={lpanel}
        alt="long panel background"
        style={imageStyle}
      />
      <div style={overlayStyle} />
      {hasWindows !== 'none' && index < setss && <WindowOverlay shape={hasWindows} color={colors} index={index} />}
    </div>
  ));

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${setss}, 240px)`,
        gridTemplateRows: `repeat(4, 80px)`,
        gap: '0',
        padding: "0px",
        border: "none",
        backgroundColor: '#111'
      }}
    >
      {images}
    </div>
  );
}

function Function3(setss, colorSelects, hasWindows, colors) {
  const containerStyle = {
    width: '120px',
    height: '80px',
    margin: '0',
    padding: '0',
    position: 'relative',
    overflow: 'hidden'
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'fill',
    margin: '0',
    padding: '0',
    position: 'relative',
    display: 'block',
    transform: 'scale(1.05)'
  };

  const overlayStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '120px',
    height: '80px',
    backgroundColor: colorSelects
  };

  const images = Array.from({ length: setss * 4 }).map((_, index) => (
    <div key={`img-container-${index}`} style={containerStyle}>
      <img
        key={`img-${index}`}
        src={bsamp}
        alt="beadboard panel background"
        style={imageStyle}
      />
      <div style={overlayStyle} />
      {hasWindows !== 'none' && index < setss && <WindowOverlay shape={hasWindows} color={colors} index={index} />}
    </div>
  ));

  return (
    <div id="garageBorder"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${setss}, 120px)`,
        gridTemplateRows: `repeat(4, 80px)`,
        gap: '0',
        padding: "0px",
        border: "none",
        backgroundColor: '#111'
      }}
    >
      {images}
    </div>
  );
}

function Function4(setss, colorSelects, hasWindows, colors) {
  // Flush panel spanning the full width
  const fullWidth = setss * 120;

  const imageStyle = {
    width: `${fullWidth}px`,
    height: '80px',
    objectFit: 'fill',
    margin: '0',
    padding: '0',
    position: 'relative',
    display: 'block'
  };

  const overlayStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: `${fullWidth}px`,
    height: '80px',
    backgroundColor: colorSelects
  };

  const images = Array.from({ length: 4 }).map((_, index) => (
    <div key={`img-container-${index}`} style={imageStyle}>
      <img
        key={`img-${index}`}
        src={fpanel}
        alt="flush panel background"
        style={imageStyle}
      />
      <div style={overlayStyle} />
      {hasWindows !== 'none' && <WindowOverlay shape={hasWindows} color={colors} index={index} />}
    </div>
  ));

  return (
    <div id="garageBorder"
      style={{
        display: 'grid',
        gridTemplateColumns: `${fullWidth}px`,
        gridTemplateRows: `repeat(4, 80px)`,
        gap: '0',
        padding: "0px",
        border: "none",
        backgroundColor: '#111'
      }}
    >
      {images}
    </div>
  );
}

function GarageSelector(props) {
  const { sizer, colors, panelss, windows, customConfig } = props;
  let setss = 0;
  let colorSelects = 'rgba(0,0,0,0)';

  if (colors === 'black') {
    colorSelects = 'rgba(0,0,0,0.75)';
  } else if (colors === 'brown') {
    colorSelects = 'rgba(78, 53, 36, 0.7)';
  } else if (colors === 'white') {
    colorSelects = 'rgba(255, 255, 255, 0.4)';
  } else if (colors === 'almond') {
    colorSelects = 'rgba(222, 208, 188, 0.5)';
  } else if (colors === 'wickertan') {
    colorSelects = 'rgba(192, 183, 161, 0.6)';
  } else if (colors === 'sandtone') {
    colorSelects = 'rgba(183, 165, 146, 0.6)';
  } else if (colors === 'terratone') {
    colorSelects = 'rgba(99, 91, 81, 0.7)';
  } else if (colors === 'charcoalgray') {
    colorSelects = 'rgba(86, 90, 92, 0.75)';
  }

  if (sizer === 16) {
    setss = 8;
  } else if (sizer === 14) {
    setss = 6;
  } else if (sizer === 8) {
    setss = 4;
  }

  let doorComponent = null;
  if (panelss === 'short') {
    doorComponent = Function1(setss, colorSelects, windows, colors);
  } else if (panelss === 'long') {
    doorComponent = Function2(setss, colorSelects, windows, colors);
  } else if (panelss === 'beadBoard') {
    doorComponent = Function3(setss, colorSelects, windows, colors);
  } else if (panelss === 'flush') {
    doorComponent = Function4(setss, colorSelects, windows, colors);
  }

  const bgConfig = customConfig || config3D[sizer];
  if (!bgConfig || !doorComponent) return null;

  return (
    <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
      <div className="preview-container" style={{
        width: '800px',
        height: `${800 * (bgConfig.h / bgConfig.w)}px`,
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        borderRadius: '8px'
      }}>
        <div style={{
          width: '100%',
          height: '100%',
          backgroundImage: `url(${bgConfig.bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: `scale(${bgConfig.bgScale || 1.0})`,
          transformOrigin: 'center center'
        }}>
          <div style={{
            position: 'absolute',
            top: `${bgConfig.top}px`,
            left: `${bgConfig.left}px`,
            transform: `perspective(1200px) rotateY(${bgConfig.rotateY}) rotateZ(${bgConfig.rotateZ}) skewY(${bgConfig.skewY}) scale(${bgConfig.scale}) scaleX(${bgConfig.stretchX || 1.0}) scaleY(${bgConfig.stretchY || 1.0})`,
            transformOrigin: 'top left'
          }}>
            {doorComponent}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GarageSelector;
